import { DateTimePicker } from '@material-ui/pickers';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import moment from 'moment';
import * as React from 'react';
import { _IEditProps } from './_IEditProps';

export const _DatetimeEdit = observer(function _DatetimeEdit(props: _IEditProps) {
	const {accessors, label, error, isRequired, classes, min, max} = props;
	const value = accessors.getter() as string;
	console.log(value, typeof value);
	function onChange(m: moment.Moment | null): void {
		if (!m) return;
		const v = m.utc().format('YYYY-MM-DD HH:mm:ss');
		accessors.handleChange({ target: { value: v } });
	}
	const transform = (v: string|undefined) => !v ? null : moment.utc(v).local().locale('de'); //TODO 'de'
	return <DateTimePicker value={transform(value)} onChange={onChange}
		strictCompareDates
		format="DD.MM.YYYY HH:mm"
		ampm={false}
		label={label}
		required={isRequired}
		error={error}
		minDate={transform(min as any) ?? undefined}
		maxDate={transform(max as any) ?? undefined}
		className={classNames(classes.datetimePickerDate, classes.datetimePicker)} />;
});
